var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"canvas-container"},[_c('canvas',{directives:[{name:"drag",rawName:"v-drag"}],ref:"timeAxis",staticClass:"time-canvas",style:({ width: _vm.axisWidth + 'px' })})])}
var staticRenderFns = []

export { render, staticRenderFns }